/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './icon-module';
export * from './icon';
export * from './icon-registry';



// WEBPACK FOOTER //
// ../../../../../src/material/icon/public-api.ts